import React from 'react';

export const VirtualViewingIcon = props => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M22.037 6.307a.75.75 0 1 1-1.285.774l1.285-.774Zm-.625 9.513a.75.75 0 1 1 1.387.572l-1.387-.572ZM12.394 2.356c-5.385 0-9.75 4.365-9.75 9.75h-1.5c0-6.214 5.037-11.25 11.25-11.25v1.5Zm-9.75 9.75c0 5.384 4.365 9.75 9.75 9.75v1.5c-6.213 0-11.25-5.037-11.25-11.25h1.5ZM20.752 7.08a9.745 9.745 0 0 0-8.358-4.725v-1.5c4.093 0 7.675 2.186 9.643 5.451l-1.285.774Zm-8.358 14.775a9.753 9.753 0 0 0 9.018-6.036l1.387.572c-1.685 4.085-5.708 6.964-10.405 6.964v-1.5Z"
            fill="currentColor"
        />
        <path
            d="M21.895 4.106v3l-2.899-.484M16 9.5V17H9V9.5"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m7 10.5 5.5-3 5.5 3"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const VideoViewingIcon = props => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx={12} cy={12} r={11} stroke="currentColor" strokeWidth={1.5} />
        <path
            d="M9 17V7l8 5-8 5Z"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
